import React, { FC } from 'react'

import { IconNotificationProps } from './IconNotification.types'
import * as Styled from './styles/IconNotification.style'

import { nonThemeableRules } from '../../ruleSet'

const IconNotification: FC<IconNotificationProps> = ({
  size = nonThemeableRules.defaultSize as number as IconNotificationProps['size'],
  isResponsive = false,
}: IconNotificationProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M28.21 38.205v.5c0 2.12-1.718 4.105-3.83 4.29a4.208 4.208 0 0 1-4.587-4.192v-.728'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M27.25 9.21v-.96A3.25 3.25 0 0 0 24 5v0a3.168 3.168 0 0 0-3.155 3.158v1.25'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M9.385 38.062a2.66 2.66 0 0 1-2.68-2.42v-.21a3.04 3.04 0 0 1 1.517-2.63c1.888-1.09 3.155-3.375 3.155-5.71l-.042-5.3A12.627 12.627 0 0 1 24.17 9.165a12.627 12.627 0 0 1 12.845 12.627l-.045 5.3c0 2.335 1.27 4.62 3.157 5.71a3.043 3.043 0 0 1 1.515 2.63v.21a2.66 2.66 0 0 1-2.68 2.42H9.385Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconNotification
